import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, EditRow, ShowRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'
import { CustomRenderStock } from '../../../../../../../../../specificComponents/Stock/customRenderStock'
import ModalCheckProductStock from '../../../../../../../../../specificComponents/Stock/ModalCheckProductStock'
import { StockParentExtendedTy } from '../../../../../../../../../specificComponents/Stock/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateStockService from './ModalCreateStockService'
import ModalEditStockService from './ModalEditStockService'

interface StockServiceProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
}

const StockService: React.FC<StockServiceProps> = ({ basicData, userPermissions }) => {

    const { t } = useTwinTranslation()

    const pageData = {
        title: t('stock', 'Inventario'),
        newText: t('addWarehouse', 'Añadir almacén')
    }

    return (
        <BaseScreenTableInner TableComponent={TableStockService} CreateModalComponent={ModalCreateStockService} EditModalComponent={ModalEditStockService} DeleteModalComponent={ModalCheckProductStock} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ 'StockParent.ProductId': basicData?.id }} basicData={basicData} />
    )
}

type TableStockServiceProps = TableComponentBaseScreenInnerProps

const TableStockService: React.FC<TableStockServiceProps> = ({ setOpened, setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<StockParentExtendedTy> = [
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            minWidth: 130,
            searchKey: 'Warehouse.name',
            sortable: true,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Warehouse?.name} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('warehouse', 'Almacén') }
            },
        },
        {
            id: 'stock',
            dataKey: 'stock',
            label: t('units', 'Unidades'),
            customRender: (parameterValue, allRowData) => <CustomRenderStock allRowData={allRowData} />,
        },
        {
            id: 'location',
            dataKey: 'location',
            label: t('location', 'Localización'),
        },
        {
            id: 'minimum',
            dataKey: 'minimum',
            label: t('minimum', 'Mínimo'),
        },
        {
            id: 'optimum',
            dataKey: 'optimum',
            label: t('optimum', 'Óptimo'),
        },
        {
            id: 'show',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('see', 'Ver'),
            customRender: (parameterValue, allRowData) => <ShowRow key={'show' + parameterValue} {...{ parameterValue, allRowData }} onClick={(e) => setOpened({
                type: 'delete',
                allRowData: allRowData
            })
            } />
        },
        {
            id: 'edit',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(v, allRowData, e) => {
                e.stopPropagation()
                e.preventDefault()
                setOpened({
                    type: 'edit',
                    allRowData: allRowData
                })
            }} />
        },
    ]
    return (
        <TwinTable columns={columns} name='productStock' getDataFrom='/api/app/product/stock/getAllStockParentsComplete'
            onRowClick={(_id, rowData) => setOpened({
                type: 'delete',
                allRowData: rowData
            })} setTableInstance={setTableInstance} defaultOrder={{ order: 'desc', defaultOrderField: 'ProductId' }} extraWhereParams={extraWhereParams} />
    )
}

export default StockService